import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

// Helper to get/set volume from cookie (0.3-1.0 float, stored as string)
const COOKIE_KEY = 'alarmVolume';
const DEFAULT_VOLUME = 1.0;
export function getInitialVolume() {
  const cookieVal = Cookies.get(COOKIE_KEY);
  if (cookieVal) {
    const parsed = parseFloat(cookieVal);
    if (!isNaN(parsed) && parsed >= 0.3 && parsed <= 1.0) {
      return parsed;
    }
  }
  return DEFAULT_VOLUME;
}

const initialState = {
  alarmVolume: getInitialVolume(), // float 0.3-1.0
};

const alarmVolumeSlice = createSlice({
  name: 'alarmVolume',
  initialState,
  reducers: {
    setAlarmVolume: (state, action) => {
      let v = action.payload;
      if (typeof v !== 'number' || isNaN(v)) v = DEFAULT_VOLUME;
      if (v < 0.3) v = 0.3;
      if (v > 1.0) v = 1.0;
      state.alarmVolume = v;
      Cookies.set(COOKIE_KEY, v.toFixed(2), { path: '/', expires: 365 });
    },
  },
});

export const { setAlarmVolume } = alarmVolumeSlice.actions;
export default alarmVolumeSlice.reducer;
